<template>
	<div class="field-settings" v-if="localField">
		<v-expansion-panels v-model="panel" flat accordion>
			<ExpansionPanel :title="'Basics'">
				<SettingSwitch
					:title="'Label'"
					:placeholder="'Type your title here'"
					:switchValue.sync="titleEnabled"
					:textFieldValue.sync="titleValue"
				/>
				<SettingSwitch :title="'Required'" :switchValue.sync="requiredEnabled" />

				<SettingSwitch :title="'Prefill'" :switchValue.sync="prefillEnabled" />
				<div class="align-center mb-4 prefill-row display-flex flex-row width-100" v-if="prefillEnabled">
					<div class="width-100">
						<div class="pt-2">Date:</div>
						<CombinedInputFieldDataMenu
							:textAreaMode="false"
							:value.sync="prefillDateValue"
							:attachTo="'.prefill-row'"
							:valuesTypes="dataInputMenuValueTypes"
						/>
						<h5 class="sub-text-description">Accepted format: YYYY-MM-dd</h5>
					</div>
				</div>
			</ExpansionPanel>
			<ExpansionPanel :title="'Explanations'">
				<SettingSwitch
					:title="'Description'"
					:placeholder="'Type your description here'"
					:switchValue.sync="descriptionEnabled"
					:textFieldValue.sync="descriptionValue"
				/>
				<SettingSwitch
					:title="'Placeholder'"
					:placeholder="'Type placeholder text'"
					:switchValue.sync="placeholderEnabled"
					:textFieldValue.sync="placeholderValue"
				/>
			</ExpansionPanel>
			<ExpansionPanel :title="'Validation'">
				<div no-gutters class="align-center" v-for="option in dataValidationItems" :key="option.key">
					<div v-if="option.optional">
						<v-checkbox
							dense
							color="primary"
							:value="localField.metadata.validations[option.key].enabled"
							@change="(v) => updateValidationEnabled(option.key, v)"
						>
							<template v-slot:label>
								<h3 class="light" style="line-height: 16px">{{ option.name }}</h3>
							</template>
						</v-checkbox>
						<v-date-picker
							ref="picker"
							@change="save"
							v-if="localField.metadata.validations[option.key].enabled"
							:value="localField.metadata.validations[option.key].value"
							@input="(v) => updateValidationValue(option.key, v)"
						></v-date-picker>
					</div>
				</div>
			</ExpansionPanel>
		</v-expansion-panels>
	</div>
</template>

<script>
import SettingSwitch from './WidgetSettings/SettingSwitch';
import ItemOnlyAllowedValueTypesMixin from './ValueTypesMixins/ItemOnlyAllowedValueTypesMixin';
import FieldSettingsMixin from '@/components/BlockEditorWidget/FieldSettings/FieldSettingsMixin';
export default {
	name: 'DatePickerFieldSettings',
	components: { SettingSwitch },
	mixins: [FieldSettingsMixin, ItemOnlyAllowedValueTypesMixin],
	methods: {
		save() {
			this.menu = false;
		},
	},
	computed: {
		prefillDateValue: {
			get() {
				return this.prefillValue;
			},
			set(value) {
				this.setLocalFieldKey('metadata.options.prefill.value', value);
			},
		},
	},
	data() {
		return {
			menu: false,
			localVal: null,
			dataValidationItems: [
				{
					key: 'min_date',
					name: 'Date must be later than',
					optional: true,
				},
				{
					key: 'max_date',
					name: 'Date must be earlier than',
					optional: true,
				},
			],
		};
	},
};
</script>
<style scoped lang="scss">
.sub-text-description {
	opacity: 0.5;
	font-size: 12px;
}
</style>
